(function () {
  'use strict';

  angular
    .module('web2print')
    .factory('Topbar', Topbar);

  Topbar.inject = [];
  function Topbar () {
    const service = {
    };

    return service;

    ////////////////
  }
})();
